
import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const CanvasCardSkeleton: React.FC = () => {
  return (
    <div className="w-full">
      <Card className="mb-2 aspect-video overflow-hidden">
        <CardContent className="h-full p-0">
          <Skeleton className="h-full w-full" />
        </CardContent>
      </Card>
      <div className="space-y-1">
        <Skeleton className="h-4 w-32" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-3 w-20" />
          <span className="bg-border h-3 w-px"></span>
          <Skeleton className="h-3 w-16" />
        </div>
      </div>
    </div>
  )
}